const pageNumberFormLocationHash = parseInt(document.location.hash.split('#page-')[1]);
const batchSize = 20;
const startIndex = 0;
const initialEndIndex = (pageNumberFormLocationHash > startIndex + batchSize)
  ? pageNumberFormLocationHash + Math.floor(batchSize / 2)
  : startIndex + batchSize;
const appendSensorPosition = endIndex => (endIndex - Math.floor(batchSize / 2));
const initialState = {
  appendSensorPosition: appendSensorPosition(initialEndIndex),
  batchSize,
  startIndex,
  endIndex: initialEndIndex,
  showPoppins: false,
  currentPage: 1,
  openedPoppinId: null,
  fullscreen: false,
  zoom: 100,
  spinner: {
    hidden: false,
    rendered: true
  },
  lastPageShow: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'BATCH_APPEND': {
      const step = Math.floor(state.batchSize / 2);
      const appendedEndIndex = state.endIndex + step;
      const cuttedEndIndex = appendedEndIndex > action.pagesCount ? action.pagesCount : appendedEndIndex;
      return Object.assign({}, state, {
        appendSensorPosition: appendSensorPosition(cuttedEndIndex),
        endIndex: cuttedEndIndex
      });
    }
    case 'CURRENT_PAGE_SET': {
      const newEndIndex = state.endIndex < action.currentPage + 10
        ? state.endIndex + Math.floor(state.batchSize / 2)
        : state.endIndex;

      return Object.assign({}, state, {
        appendSensorPosition: appendSensorPosition(newEndIndex),
        currentPage: action.currentPage,
        endIndex: newEndIndex
      });
    }
    case 'OPENED_POPPIN_TOGGLE':
      return Object.assign({}, state, { openedPoppinId: (state.openedPoppinId === action.id ? null : action.id) });
    case 'OPENED_POPPIN_CLOSE':
      return Object.assign({}, state, { openedPoppinId: null });
    case 'FULLSCREEN_OFF':
      return Object.assign({}, state, { fullscreen: false });
    case 'FULLSCREEN_TOGGLE':
      return Object.assign({}, state, { fullscreen: !state.fullscreen });
    case 'LAST_PAGE_SET_VISIBLE':
      return Object.assign({}, state, { lastPageShow: true });
    case 'POPPINS_SHOW':
      return Object.assign({}, state, { showPoppins: true });
    case 'POPPINS_TOGGLE':
      return Object.assign({}, state, { showPoppins: !state.showPoppins });
    case 'SPINNER_DONT_RENDER':
      return Object.assign({}, state, {
        spinner: Object.assign({}, state.spinner, {
          rendered: false
        })
      });
    case 'SPINNER_HIDE':
      return Object.assign({}, state, {
        spinner: Object.assign({}, state.spinner, {
          hidden: true
        })
      });
    case 'SPINNER_SHOW':
      return Object.assign({}, state, {
        spinner: Object.assign({}, state.spinner, {
          hidden: false
        })
      });
    case 'ZOOM_IN':
      return (state.zoom <= 180)
        ? Object.assign({}, state, { zoom: state.zoom + 20 })
        : state;
    case 'ZOOM_OUT':
      return (state.zoom >= 80)
        ? Object.assign({}, state, { zoom: state.zoom - 20 })
        : state;
    default:
      return state;
  }
};

export { initialState, reducer };
export default reducer;
